<template>
  <div>
    <modal-edit-invoice-texts
      v-if="showEditTexts"
      :showModal="showEditTexts"
      :onClickCancel="hideModal"
      :invoiceTexts="invoiceTexts"
      :mailType="selectedMailType.Type"
      @saveInvoiceTexts="invoiceTextSaved"
    ></modal-edit-invoice-texts>

    <transition
      name="fade"
      mode="out-in"
    >
      <ui-loader v-if="isLoading" />
      <div v-else>
        <ui-section-header :showEdit="false">
          <template slot="title">
            {{
              $t(
                'Components.Settings.Invoice.InvoiceTextSettings.Title_InvoiceTextSettings'
              )
            }}
          </template>
        </ui-section-header>
        <div class="tabs is-boxed">
          <ul>
            <li
              v-for="mailType in mailTypes"
              :key="mailType.Id"
              :class="{ 'is-active': selectedMailType.Id === mailType.Id }"
            >
              <a @click="setSelectedMailType(mailType)">{{ mailType.Name }}</a>
            </li>
          </ul>
        </div>

        <transition
          name="fade"
          mode="out-in"
        >
          <div :key="selectedMailType.Type">
            <div v-if="activeTexts && activeTexts.length > 0">
              <ui-section-header
                :showEdit="true"
                :editFunction="
                  function () {
                    setShowEditTexts('footer')
                    return true
                  }
                "
              >
                <template v-slot:title>{{
                  $t(
                    'Components.Settings.Invoice.InvoiceTextSettings.Title_Footer'
                  )
                }}</template>
              </ui-section-header>

              <div class="columns">
                <div
                  v-for="(textLanguage, index) in activeTexts"
                  :key="index"
                  class="column"
                >
                  <div class="title is-5">
                    {{
                      $t('LanguageLabels.Language' + textLanguage.LanguageId)
                    }}
                  </div>

                  <div
                    class="textWrapper content has-custom-scrollbar p-4"
                    v-html="textLanguage.Footer"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import invoiceProvider from '@/providers/invoice'

const ModalEditInvoiceTexts = () =>
  import('@/components/Settings/Invoice/ModalEditInvoiceText')

export default {
  components: {
    'modal-edit-invoice-texts': ModalEditInvoiceTexts,
  },

  data() {
    return {
      isLoading: true,
      activeTexts: [],
      editItem: '',
      invoiceTexts: [],
      locationId: Number(this.$route.params.locationId),
      mailTypes: [
        {
          Id: 0,
          Name: this.$t(
            'Components.Settings.Invoice.InvoiceTextSettings.MailType_Standard'
          ),
          Type: 'Standard',
        },
        {
          Id: 1,
          Name: this.$t(
            'Components.Settings.Invoice.InvoiceTextSettings.MailType_Deposit'
          ),
          Type: 'Deposit',
        },
        {
          Id: 4,
          Name: this.$t(
            'Components.Settings.Invoice.InvoiceTextSettings.MailType_Credit'
          ),
          Type: 'Credit',
        },
        {
          Id: 2,
          Name: this.$t(
            'Components.Settings.Invoice.InvoiceTextSettings.MailType_FirstReminder'
          ),
          Type: 'FirstReminder',
        },
        {
          Id: 3,
          Name: this.$t(
            'Components.Settings.Invoice.InvoiceTextSettings.MailType_SecondReminder'
          ),
          Type: 'SecondReminder',
        },
      ],
      modalTitle: '',
      selectedMailType: {
        Id: 0,
        Name: this.$t(
          'Components.Settings.Invoice.InvoiceTextSettings.MailType_Standard'
        ),
        Type: 'Standard',
      },
      showModal: false,
      showEditTexts: false,
    }
  },

  created() {
    this.getLocationInvoiceTexts()
  },

  methods: {
    getLocationInvoiceTexts() {
      let self = this
      invoiceProvider.methods
        .getLocationInvoiceTexts(this.locationId)
        .then((response) => {
          if (response.status === 200) {
            this.invoiceTexts = response.data

            this.setSelectedMailType(this.selectedMailType)
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    setSelectedMailType(mailType) {
      let self = this
      self.activeTexts = self.invoiceTexts.filter(
        (it) => it.InvoiceMailType === mailType.Type
      )

      self.selectedMailType = mailType
    },

    invoiceTextSaved(invoiceTexts) {
      this.invoiceTexts = invoiceTexts
      this.setSelectedMailType(this.selectedMailType)
    },

    setShowEditTexts(editItem) {
      this.modalTitle =
        editItem === 'mail' ? 'Edit mail text' : 'Edit footer text'
      this.editItem = editItem
      this.showModal = true
      this.showEditTexts = true
    },

    hideModal() {
      this.modalTitle = ''
      this.editItem = ''
      this.showModal = false
      this.showEditTexts = false
    },
  },
}
</script>

<style lang="scss" scoped>
.textWrapper {
  border: 1px solid $grey-light;
  height: 300px;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
